export default __webpack_public_path__ + "static/why-2380e25cffc0ddbee637cb3923a692f9.gif";